/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
    GraphQLObjectType as ObjectType,
    GraphQLString as StringType,
    GraphQLID as ID,
    GraphQLNonNull as NonNull,
} from 'graphql';


const ServiceType = new ObjectType({
    name: 'ServiceItem',
    description: 'Cet objet represente un service',
    fields: () => ({
        id: {
            type: new NonNull(ID),
            description: 'Le id du service',
            resolve: (root) => root.id
        },
        slug: {
            type: StringType,
            description: 'Le slug du service',
            resolve: (root) => root.slug
        },
        title: {
            type: StringType,
            description: 'Le titre du service',
            resolve: (root) => root.acf.titre_service_accueil_hover
        },
        content: {
            type: StringType,
            description: 'Le content du service',
            resolve: (root) => root.content.rendered
        },
        titleHover: {
            type: StringType,
            description: 'Le titre du service sur hover',
            resolve: (root) => root.title.rendered
        },
        contentHover: {
            type: StringType,
            description: 'Le content du service sur hover',
            resolve: (root) => root.acf.texte_service_accueil_hover
        },
        lienPage: {
            type: StringType,
            description: 'Le lien de la page du service',
            resolve: (root) => root.acf.lien_page
        },
    }),
});

export default ServiceType;



// WEBPACK FOOTER //
// ./data/types/ServiceType.js